import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { MeetingPrepStoryRemoval } from "@acto/taskpane/core/domain";

const RemovedMeetingPrepStoriesQuery = graphql(`
  query GetRemovedMeetingPrepStories($clientId: ID!) {
    removedMeetingPrepStories(clientId: $clientId) {
      id
      __typename
      clientId
      storyKey
    }
  }
`);

export function useRemovedMeetingPrepStories(clientId?: string): DataAccessResult<MeetingPrepStoryRemoval> {
  const [result] = useQuery({
    query: RemovedMeetingPrepStoriesQuery,
    variables: { clientId: clientId ?? "" },
    pause: !clientId,
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = !data && isFetching;

  const removals = useMemo(() => data?.removedMeetingPrepStories.map(MeetingPrepStoryRemoval.fromGraphql), [data]);

  return {
    data: removals,
    isFetching,
    isPending,
    error,
  };
}
